const RENT = "Renta";
const SALE = "Venta";
const RENT_PLUS = "Renta";
const BOTH = "Ambos";
const S_RENT = "Rentas";
const S_SALE = "Ventas";
const S_RENT_PLUS = "Rentas Plus";
const C_RENT = "(33) 3040-8700";
const C_SALE = "(33) 3615-6905, (33) 3615-5612, (33) 3615-6917";
const C_RENT_PLUS = "(33) 3044-9900";

const NUM_RENT = 1;
const NUM_SALE = 2;
const NUM_RENT_PLUS = 3;
const NUM_BOTH = 4;

const get = {
  [NUM_RENT]: RENT,
  [NUM_SALE]: SALE,
  [NUM_RENT_PLUS]: RENT_PLUS
};

const getDetail = {
  [NUM_RENT]: S_RENT,
  [NUM_SALE]: S_SALE,
  [NUM_RENT_PLUS]: S_RENT_PLUS
};

const contact = {
  [NUM_RENT]: C_RENT,
  [NUM_SALE]: C_SALE,
  [NUM_RENT_PLUS]: C_RENT_PLUS
};

export default {
  get,
  contact,
  getDetail,
  RENT,
  SALE,
  RENT_PLUS,
  BOTH,
  NUM_RENT,
  NUM_SALE,
  NUM_RENT_PLUS,
  NUM_BOTH
};
